'use strict';

//ヘッダーのスクリプト
(() => {
  const V = window.VIEWPORT_CONFIG = {
    PC_BREAKPOINT: 768,
    TABLET_WIDTH: 1280,
    SP_WIDTH: 390
  };

  let timeoutId;
  const apply = () => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    const viewportContent = screen.width >= V.PC_BREAKPOINT ?
      `width=${V.TABLET_WIDTH}` :
      `width=${V.SP_WIDTH}`;

    viewport.setAttribute('content', viewportContent);
  };

  const debouncedApply = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(apply, 120);
  };

  apply();
  window.addEventListener('resize', debouncedApply, {
    passive: true
  });
  window.addEventListener('orientationchange', apply, {
    passive: true
  });
})();
